import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { ActualizarAgregarUsuarioParams, BuscarUsuarioResponse, PerfilProps, UsuarioDelegadoProps, UsuarioProps, UsuarioReasignacionCancelacionResponse, UsuarioResponse } from '../../interfaces/admin/UsuarioInterface';
import { HttpResponse, CambiarContrasenaParams } from '../../interfaces/auth/AuthInterface';

export const Usuarios = () => {

    return new Promise<UsuarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/', token)
            .then( ({ data } : { data :UsuarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarUsuario = ( params: ActualizarAgregarUsuarioParams ) => {

    return new Promise<UsuarioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Actualizar', params, token)
            .then( ({ data } : { data : UsuarioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,     
                    idUsuario: 0,
                    curp: '',
                    nombres: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,
                    idPuesto: 0,
                    puesto: '',
                    idTipoUsuario: 0,
                    tipoUsuario: '',
                    restablecerContrasena: false,
                    idUsuarioFirmaElectronica: 0,
                    contrasenaFirmaElectronica: '',
                    fechaExpiracionFirmaElectronica: '',
                    idUsuarioDelegado: 0,
                    idUsuarioSistemaTurnos: 0,
                    roles: [],
                });
            });
        }

    });

}

export const AgregarUsuario = ( params: ActualizarAgregarUsuarioParams ) => {

    return new Promise<UsuarioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Agregar', params, token)
            .then( ({ data } : { data : UsuarioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,     
                    idUsuario: 0,
                    curp: '',
                    nombres: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,
                    idPuesto: 0,
                    puesto: '',
                    idTipoUsuario: 0,
                    tipoUsuario: '',
                    restablecerContrasena: false,
                    idUsuarioFirmaElectronica: 0,
                    contrasenaFirmaElectronica: '',
                    fechaExpiracionFirmaElectronica: '',
                    idUsuarioDelegado: 0,
                    idUsuarioSistemaTurnos: 0,
                    roles: [],              
                });
            });
        }

    });

}

export const BuscarUsuarioRH = ( curp: string ) => {

    return new Promise<BuscarUsuarioResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Usuario/BuscarUsuario/${ curp }`, token)
            .then( ({ data } : { data : BuscarUsuarioResponse} ) => {
                resolve( data );
            })
            .catch( (error: AxiosError) => {
                
                const data: BuscarUsuarioResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}

export const BuscarUsuariosDelegados = () => {

    return new Promise<UsuarioDelegadoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/BuscarUsuariosDelegados', token)
            .then( ({ data } : { data : UsuarioDelegadoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const CambiarContrasena = ( params: CambiarContrasenaParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/CambiarContrasena/', params, token)
            .then( ({ data } : { data : HttpResponse} ) => {
                resolve( data );
            })
            .catch( (error: AxiosError) => {
                
                const data: HttpResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}

export const ObtenerPerfil = () => {

    return new Promise<PerfilProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/ObtenerPerfil/', null, token)
            .then( ({ data } : { data : PerfilProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({
                    correoElectronico:      '',
                    curp:                   '',
                    rfc:                    '',
                    nombres:                '',
                    apellido1:              '',
                    apellido2:              '',
                    puesto:                 '',
                    tipoUsuario:            '',
                    firmaElectronica:       false,
                    contrasena:             '',
                    roles:                  [],
                    diasExpiracionFirmaElectronica: 0,
                    success:                false,
                    message:                '',
                });
            });
        }

    });

}

export const ObtenerUsuariosReasignacionCancelacion = () => {

    return new Promise<UsuarioReasignacionCancelacionResponse[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/ObtenerUsuariosReasignacionCancelacion', token)
            .then( ({ data } : { data :UsuarioReasignacionCancelacionResponse[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}
